import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DISPLAY_DATE_FORMAT } from '../../../config/helpers';
import { imagePropTypes } from '../../../propTypes';

import Button from '../Atoms/Button';
import Picture from '../Picture';

const propTypes = exact({
  ctaButtonText: PropTypes.string,
  description: PropTypes.string,
  heading: PropTypes.string,
  id: PropTypes.number.isRequired,
  image: imagePropTypes,
  publishedDate: PropTypes.string.isRequired,
  subHeading: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

const defaultProps = {
  ctaButtonText: 'Read More',
  heading: '',
  image: undefined,
  description: '',
  subHeading: '',
};

function NewsItem(props) {
  return (
    <article className="NewsItem">
      {props.image && (
        <Picture
          {...props.image}
          className="NewsItem_image"
          sizes={[
            [100, 1.77], // from 0
            [50, 1.77], // from 480
            [33, 1.77], // from 768
            [33, 1.77], // from 1024
            ['480px', 1.77], // from 1440
          ]}
        />
      )}
      <div className="NewsItem_body">
        <span className="NewsItem_date">
          {moment(props.publishedDate).format(DISPLAY_DATE_FORMAT)}
        </span>
        <h3 className="NewsItem_title">{props.title}</h3>
        {props.description && <span className="NewsItem_description">{props.description}</span>}
      </div>
      <div className="NewsItem_buttonContainer">
        <Button
          blockName="NewsItem_button"
          elementType="link"
          modifier="ghost"
          text={props.ctaButtonText}
          url={props.url}
        />
      </div>
    </article>
  );
}

NewsItem.propTypes = propTypes;
NewsItem.defaultProps = defaultProps;

export default NewsItem;
